import type { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';

export interface FeatureChipProps {
  title: string;
  sub: string;
  icon: ReactElement;
  delay?: number;
}

/** One segment of the glass feature bar: a gradient icon tile + a two-line label. */
export default function FeatureChip({ title, sub, icon, delay = 0 }: FeatureChipProps) {
  const reduce = useReducedMotion();
  return (
    <Box
      component={motion.div}
      initial={reduce ? false : { opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, delay }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.15,
        px: { xs: 1.75, lg: 2.25 },
        py: 1.5,
        flex: '1 1 0',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: 34,
          height: 34,
          borderRadius: 2,
          display: 'grid',
          placeItems: 'center',
          background: 'linear-gradient(135deg,#4F46E5,#7C3AED)',
          boxShadow: '0 6px 16px rgba(79,70,229,0.4)',
          '& svg': { fontSize: 18, color: '#fff' },
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#F1F5FF', lineHeight: 1.2, whiteSpace: 'nowrap' }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 11.5, color: 'rgba(203,213,225,0.72)', lineHeight: 1.25, whiteSpace: 'nowrap' }}>
          {sub}
        </Typography>
      </Box>
    </Box>
  );
}
